import PropTypes from 'prop-types';

const identityModel = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

const baseCategoryModel = PropTypes.shape({
  id: identityModel.isRequired,
  slug: PropTypes.string,
  title: PropTypes.string.isRequired,
});

const fileModel = PropTypes.shape({
  id: identityModel.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
});

const imageTransformModel = PropTypes.shape({
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
});

const imageModel = PropTypes.shape({
  id: identityModel.isRequired,
  title: PropTypes.string.isRequired,
  originalFilename: PropTypes.string,
  url: PropTypes.string,
  cpEditUrl: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  transforms: PropTypes.objectOf(imageTransformModel.isRequired).isRequired,
  caption: PropTypes.string,
});

const domElementModel = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.element,
  PropTypes.bool,
  PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.bool,
  ])),
]);

export {
  identityModel,
  baseCategoryModel,
  fileModel,
  imageTransformModel,
  imageModel,
  domElementModel,
};
